module.exports = __webpack_public_path__ + "img/img29.7fd51bb1.jpg";